export const SET_PANEL = 'SET_PANEL';
export const SET_MODULE = 'SET_MODULE';
export const SET_CONTENT_URL = 'SET_CONTENT_URL';